import { IProfileAuthOutputModel } from "interfaces/auth";
import { IPaginateTable } from "interfaces/common";

export interface IMediaOutputModel {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: null;
  title: string;
  fileName: string;
  path: string;
  metadata: TMetadataMedia;
  createdBy: IProfileAuthOutputModel;
  alt: string;
  note: string;
  description: string;
  searchValue: string;
}

export interface IGetMediaForPaginateInputModel extends IPaginateTable {
  searchValue?: string;
  fromDate?: string;
  toDate?: string;
}

export interface IUpdateMediaInputModel extends IMediaOutputModel {}

export type TMetadataMedia = {
  type: string;
  width: number;
  height: number;
  size: string | number;
  originName: string;
};

export enum EDestinationMediaUpload {
  "Cloud" = "CLOUD",
  "Hosting" = "HOSTING",
}
